
export const SSAP_FLOW_VERSION = 2;
export const ENABLED = 'Enabled';
export const DISABLED = 'Disabled';

export const FOSTER_CARE_AGE_LIMIT = 21;
export const UNEMPLOYMENT_INCOME_ATTESTATION_SUPPORTED_YEARS = [ 2021 ];

export const SSAP_DATE_FORMATS = {
    HRA_START_DATE: 'HRA_START_DATE'
};

export const NO_PRIOR_DATA = 'NO_PRIOR_DATA';
export const NOT_PROVIDED = 'NOT_PROVIDED';

export const USPS_GENERAL_DELIVERY_ADDRESS = 'General Delivery';

export const LOT_NUMBER_LABEL = 'Lot Number';

export const SAFE_HOME_ADDRESS = {
    streetAddress1: null,
    streetAddress2: 'PO BOX 17370',
    postalCode: '55117',
    city: 'Saint Paul',
    state: 'MN',
    county: 'Ramsey',
    countyCode: '27123',
    primaryAddressCountyFipsCode: '27123',
};

// Used to reset the mailing address back to blank, editable fields when
// Safe At Home is unchecked (undoing the SAFE_HOME_ADDRESS defaults above)
export const CLEAR_MAILING_ADDRESS = {
    streetAddress1: null,
    streetAddress2: null,
    postalCode: null,
    city: null,
    state: null,
    county: null,
    countyCode: null,
    primaryAddressCountyFipsCode: null,
};

export const SSAP_JSON_PROP_NAMES = {
    COUNTY_CODE: 'countyCode',
    EMAIL_ADDRESS: 'emailAddress',
    EMAIL_ME: 'emailMe',
    HOME_ADDRESS: 'homeAddress',
    LIVING_ARRANGEMENT: 'livingArrangement',
    MAILING_ADDRESS: 'mailingAddress',
    NO_HOME_ADDRESS: 'noHomeAddressIndicator',
    OUT_OF_STATE_ATTESTATION: 'outOfStateAttestation',
    PHONE: 'phone',
    PHONE_NUMBER: 'phoneNumber',
    STATE: 'state',
    STREET_ADDRESS_1: 'streetAddress1',
    TEXT_ME: 'textMe',
    EMERGENCY_CONTACT_INFO: 'emergencyContactInfo'
};

export const SSAP_INCOME_PROP_NAMES = {
    SOURCE_NAME: 'sourceName'
};

export const SSAP_JSON_RESIDENCY_PROPS = {
    RESIDENCY_REASONS: 'residencyReasons',
    STATE_RESIDENT: 'stateResident',
    PLAN_TO_MAKE_HOME: 'planToMakeHome',
    MOVED_IN_DUE_TO_WORK: 'movedInDueToWork',
    MOVED_RECENTLY: 'movedRecently',
    MOVE_IN_DATE: 'moveInDate',
    VISITING_REASON: 'visitingForPersonalReason'
};

export const SSAP_MEDICAL_EMERGENCY_PROPS = {
    NEEDS_EMA: 'needsEMA',
    DATE_EMA_BEGAN: 'dateEMABegan',
    HAS_EMA_ENDED: 'hasEMAEnded',
    DATE_EMA_ENDED: 'dateEMAEnded'
};

export const PHONE_TYPES = {
    HOME: 'HOME',
    MOBILE: 'MOBILE'
};
export const GENDER_TYPES = {
    MALE: 'male',
    FEMALE: 'female'
};

export const INLINE_ELIGIBILITY_VALUES = {
    YES: 'YES',
    NO: 'NO', // for unit tests, it might not exist
    NOT_APPLICABLE: 'NA'
};

export const INCOME_SOURCES_SUMMARY_GROUPING = [
    [
        'ssap.input.option.job',
        'ssap.input.option.pension',
        'ssap.input.option.rental_royalty',
        'ssap.input.option.alimony',
        'ssap.input.option.scholarship'
    ],
    [
        'ssap.input.option.self_employment',
        'ssap.input.option.ss_benefits',
        'ssap.input.option.farming_fishing',
        'ssap.input.option.investment'
    ],
    [
        'ssap.input.option.retirement',
        'ssap.input.option.capital_gains',
        'ssap.input.option.unemployment',
        'ssap.input.option.other_income'
    ]
];